<script setup lang="ts">
defineProps({
  blok: Object,
});

const localePath = useLocalePath();
</script>

<template>
  <section
    class="py-44 bg-gradient-to-b from-chsc-indigo-500 to-chsc-indigo-soft overflow-hidden max-[1025px]:py-20"
  >
    <UiContainer class="relative">
      <img
        src="https://a.storyblok.com/f/291812700015950/238x238/f299c94110/home-cocoa-01.png"
        class="absolute -top-20 left-20 max-[1025px]:hidden"
      />
      <img
        src="https://a.storyblok.com/f/291812700015950/356x356/8e69372724/home-cocoa-02.png"
        class="absolute top-10 -left-44 max-[1025px]:hidden"
      />
      <img
        src="https://a.storyblok.com/f/291812700015950/464x464/3beda4a723/home-cocoa-03.png"
        class="absolute top-0 -right-72 max-[1025px]:hidden"
      />
      <div class="relative z-1 flex items-center justify-center text-center">
        <header
          class="px-44 col-span-6 pb-12 [&>h2]:leading-[60px] [&>h2]:mb-6 [&>h2]:font-londrina-solid [&>h2]:text-chsc-yellow [&>h2]:fs-7xl [&>h2>strong]:fs-9xl [&>h2>strong]:leading-[60px] [&>p]:font-eb-garamond [&>p]:fs-2xl [&>p]:text-white max-[769px]:col-span-12"
        >
          <StoryblokRichText :doc="blok?.header" />
          <footer class="mt-6">
            <UButton :to="localePath('/state-of-cocoa')" :label="blok?.cta" size="xl" />
          </footer>
        </header>
      </div>
    </UiContainer>
  </section>
</template>
